module.exports = __webpack_public_path__ + "static/img/groundabout6.4977a96d.png";